import React from "react";
import { Modal, Box, Typography, Button, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { Rating } from "react-simple-star-rating";
import { isDarkMode } from "../utils/constants";
import GoogleReviewCTA from "./GoogleReviewCTA";

const reviewModalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  display: "flex",
  flexDirection: "column",
  justifyContent: 'center',
  gap: 2,
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: isDarkMode ? "#222222" : '#FFFFFF', 
  boxShadow: 24,
  alignItems: "center",
  color: "white", 
  p: 4,
  borderRadius: 2,
  outline: "none",
};

const ReviewModal = ({
  open,
  onClose,
  onSubmit,
  onRating,
  rating,
  isGoogle = false,
}) => {
  const disableSubmit = rating === 0;
  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={reviewModalStyle}>
        <Box
          sx={{
            position: "absolute",
            top: 8,
            right: 8,
          }}
        >
          <IconButton
            aria-label="Close review modal"
            onClick={onClose}
            sx={{
              color: isDarkMode ? "white" : "black",
              p: 0.5,
            }}
            size="small"
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 2,
          }}
        >
          <Typography sx={{
            textAlign: 'center',
            color: isDarkMode ? "white" : "black"
          }} id="modal-modal-title" variant="h6" component="h2">
            {isGoogle
              ? "Would you like to leave us Google review?"
              : "Enjoying Incite?"}
          </Typography>
          {!isGoogle && <Rating onClick={onRating} initialValue={null} />}
          {isGoogle ? (
            <GoogleReviewCTA onClick={onSubmit} isDarkMode={isDarkMode} />
          ) : (
            <Button
              disabled={disableSubmit}
              sx={{
                backgroundColor: isDarkMode ? "#3B3B3B" : "#E8E8E8",
                color: isDarkMode ? "white" : "black",
                "&:hover": { opacity: 0.8 },
                "&.Mui-disabled": {
                  color: "grey",
                  backgroundColor: isDarkMode ? "#2f2f2f" : "#f0f0f0",
                  opacity: 1,
                },
              }}
              variant="contained"
              onClick={onSubmit}
            >
              {isGoogle ? "Google Reviews" : "Submit"}
            </Button>
          )}
        </Box>
      </Box>
    </Modal>
  );
};

export default ReviewModal;
